import { render, staticRenderFns } from "./DetailSwiper.vue?vue&type=template&id=4f33b566&"
import script from "./DetailSwiper.vue?vue&type=script&lang=js&"
export * from "./DetailSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports